import { render, staticRenderFns } from "./InventarioMuniciones.vue?vue&type=template&id=5f2679ff"
import script from "./InventarioMuniciones.vue?vue&type=script&lang=js"
export * from "./InventarioMuniciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports